module.exports = __webpack_public_path__ + "static/media/reservation_detail.c557e5b5.jpg";